import ProjectsPage from "./ProjectsPage";

export default [
    {
        path: "/projects",
        name: "projects",
        component: ProjectsPage
    }
];